<template>
  <span>
    <span v-if="editing">
      <div class="input-group">
        <textarea-autosize class="form-control" v-model="taskTitle" @blur.native="blur" @focus="focus"></textarea-autosize>
        <div class="input-group-append">
          <span class="btn btn-primary do-not-collapse" @click="blur">Save</span>
        </div>
      </div>
    </span>
    <span v-else>
      <span v-if="!task.discarded" class="float-right pointer" data-toggle="modal" :data-target="'#deleteTaskItemModal' + task_item.id">
        <i class="material-icons">cancel</i>
      </span>

      <input type="checkbox" v-on:change="toggleCompleteStatus(task_item)" v-model="task_item.completed" :id="label_id(task_item)">
      <span class="ml-1">
        <span class="checklist-item do-not-collapse" v-on:click.self="focus" v-html="generateTelLinks(titleContent())" v-bind:class="{ 'text-muted strikethrough': task_item.completed}"></span>
      </span>

      <div class="modal fade" :id="'deleteTaskItemModal' + task_item.id">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Are you sure you want to delete this checklist item?</h5>
            </div>
            <div class="modal-body">
              <div> Are you sure you want to delete? -
                <em>
                  {{task_item.title}}
                </em>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary" @click="deleteTaskItem(task_item)">Delete Checklist Item</button>
            </div>
          </div>
        </div>
      </div>
    </span>
  </span>

</template>

<script>
import api from "api";
import TaskItem from "components/TaskItem";

export default {
  components: {
    TaskItem
  },
  props: {
    task_item: {
      type: Object
    },
    task: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      editing: false,
      taskTitle: this.task_item.title,
    };
  },
  methods:{
    label_id(task_item){
      return 'task-item-' + task_item.id
    },
    toggleCompleteStatus(task_item){
      api.toggleTaskItemStatus(task_item.id).then(response => {
      });
    },
    deleteTaskItem(task_item) {
      api.deleteTaskItem(task_item.id).then(response => {
        $('body').removeClass('modal-open')
        $(".modal-backdrop").hide();
      });
    },
    saveTitle(){
      if(this.taskTitle != this.task_item.title){
        api.updateTaskItem(this.task_item.id, { title: this.taskTitle }).then(response => {
          this.editing=false
        });
      } else {
        this.editing=false;
      }
    },
    titleContent(){
      return (this.index + 1) +  '. ' + this.taskTitle
    },
    blur(){
      this.saveTitle()
    },
    focus(){
      this.editing = true;
    }
  }
}
</script>
